import React from "react";
import { Field } from "formik";
import TextField from "@material-ui/core/TextField";
import '../AddNewPers.css';


export const Form1054 = formikProps => {
    const { errors, touched } = formikProps;
    return (
        <div className="page-container">
            <h5 className="page-header">Section 5 of 8 - Form 1054</h5>
                <div id="radio-group" className="attribute-header">Has the lender submitted a completed 1054?</div>
                <div role="group" aria-labelledby="radio-group" className="radio-container">
                    <label>
                        <Field type="radio" name="submittedComplete1054Indicator" value="true" />
                        Yes
                    </label>
                    <label>
                        <Field type="radio" name="submittedComplete1054Indicator" value="false" />
                        No
                    </label>
                </div>
                <div id="radio-group-1" className="attribute-header">Has the lender included the Attorney Opinion Letter?</div>
                <div role="group" aria-labelledby="radio-group-1" className="radio-container">
                    <label>
                        <Field type="radio" name="includedAttornerOpnionLetterIndicator" value="true" />
                        Yes
                    </label>
                    <label>
                        <Field type="radio" name="includedAttornerOpnionLetterIndicator" value="false" />
                        No
                    </label>
                </div>
                <div className="attribute-header">Exceptions</div>
                <Field 
                    name="exceptions1054" 
                    as={TextField} 
                    className="page-attribute"
                    variant="outlined"
                    inputProps={{
                        'aria-label': 'exceptions 1054'
                      }}
                />
        </div>
    );
};